import { Component, OnInit, forwardRef } from '@angular/core';
import { NavController, AlertController, ToastController, LoadingController, ActionSheetController, ModalController, NavParams, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AcompanhamentoGerenciarPage } from '../acompanhamento-gerenciar/acompanhamento-gerenciar.page';
import { AcompanhamentoProvider } from 'src/app/services/acompanhamento/acompanhamento';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';

@Component({
  selector: 'app-acompanhamento-pessoa',
  templateUrl: './acompanhamento-pessoa.page.html',
  styleUrls: ['./acompanhamento-pessoa.page.scss'], 
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SemRegistroComponent
  ],
})
export class AcompanhamentoPessoaPage implements OnInit {
  historicoList: any = [];
  idPessoa: any = '';

  constructor(
    public navCtrl: NavController,
    public acompanhamentoProvider: AcompanhamentoProvider,
    public alertCtrl: AlertController,
    private translate: TranslateService,
    public toastCtrl: ToastController,
    public loadingController: LoadingController,
    public actionSheetCtrl: ActionSheetController,
    public modalCtrl: ModalController,
    public navParams: NavParams
  ) {
    this.idPessoa = this.navParams.get('idPessoa');
    this.buscar();
  }

  ngOnInit() {
  }

  buscar() {
    this.acompanhamentoProvider.getHistoricoByIdPessoa(this.idPessoa).subscribe((data) => {
      this.historicoList = data;
    });
  }

  async detalhes(acompanhamento: any) {
    const modalPage = await this.modalCtrl.create({ component: AcompanhamentoGerenciarPage, componentProps: { acompanhamento: acompanhamento, isResponsavel: false, showDescricao: true } });
    modalPage.present();

    const { data } = (await modalPage.onWillDismiss());
    if (data) {
      this.buscar();
    }
  }

  getFontColor(acompanhamento: { cor: any; }) {
    return acompanhamento.cor;
  }

  getIcon(acompanhamento: { icone: string | string[]; }) {
    if (acompanhamento.icone.includes(' fa-')) {
      return acompanhamento.icone;
    } else {
      return 'fas fa-' + acompanhamento.icone;
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
